// import {exec} from 'child_process';
import { SWITCH_LANGUAGE, TOGGLE_COLLAPSED_NAV, WINDOW_WIDTH } from "constants/ActionTypes";
import { LAYOUT_TYPE, NAV_STYLE, THEME_COLOR_SELECTION, THEME_TYPE } from "../../constants/ThemeSetting";
import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { FETCH_ORGANISATION_DATA_SUCCESS, FETCH_ORGANISATION_SUCCESS } from "../../constants/ActionTypes";
import { history } from "../store";
import Swal from "sweetalert2";

const { exec } = require('child_process');

export function toggleCollapsedSideNav(navCollapsed) {
  return { type: TOGGLE_COLLAPSED_NAV, navCollapsed };
}

export function updateWindowWidth(width) {
  return { type: WINDOW_WIDTH, width };
}

export function setThemeType(themeType) {
  return { type: THEME_TYPE, themeType };
}

export function setThemeColorSelection(colorSelection) {
  return { type: THEME_COLOR_SELECTION, colorSelection };
}

export function onNavStyleChange(navStyle) {
  return { type: NAV_STYLE, navStyle };
}

export function onLayoutTypeChange(layoutType) {
  return { type: LAYOUT_TYPE, layoutType };
}

export function switchLanguage(locale) {
  return {
    type: SWITCH_LANGUAGE,
    payload: locale
  };
}

export function fetchAppVersionSuccess(data) {
  return {
    type: 'FETCH_APP_VERSION',
    data
  };
}

export const fetchAppVersion = () => {
  return async (dispatch) => {

    const uiVersion = process.env.REACT_APP_VERSION || '-';
    const uiBranch = process.env.REACT_APP_ENVIRONMENT || '-';

    const appInfo = await axios.get('/common/app-info');
    // console.log(appInfo);

    dispatch(fetchAppVersionSuccess({ uiVersion, uiBranch, ...appInfo.data }))
  }
};

export const fetchOrganisationSuccess = ({ data }) => {
  return {
    type: FETCH_ORGANISATION_SUCCESS,
    data
  };
};

export const fetchOrganisation = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());
    // console.log(id);
    try {
      const response = await axios.get(`/setting/organisation/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchOrganisationSuccess({ data: { ...response.data, time: new Date().getTime() } }));
    } catch
    (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const updateOrganisation = (payload, id) => {
  // console.log(payload, id);
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      // formData.append('name', payload.name);
      formData.append('files', payload.files.file);
      formData.append('filesFavicon', payload.filesFavicon.file);

      // if(typeof payload.logo !== 'string')
      //   formData.append('files', payload.files.file);
      // else formData.append('logo', payload.logo);

      Object.keys(payload).forEach(key => {
        if (key === 'files' || key === 'filesFavicon') {
          return
        }
        formData.append(key, payload[key]);
      });
      await axios.put(`/setting/organisation/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      dispatch(fetchSuccess());
      dispatch(fetchOrganisation(id));
      Swal.fire({
        title: `<strong>Organisation updated successfully</strong>`,
        icon: 'success'
      });
      // history.push('/setting');
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const exportOrgData = () => {
  return async (dispatch) => {

    dispatch(fetchStart());
    // console.log(id);
    try {
      const response = await axios.get(`/security/export`);
      dispatch(fetchSuccess());
      Swal.fire({
        title: `<strong>Data Export </strong>`,
        html: `<div><p>Exported data can be seen in the table below!</p><p>Click refresh to see data</p><p><small>An email will also be sent to you once the backup is ready for download.</small></p></div>`,
        icon: 'success'
      });
      // dispatch(fetchOrganisationSuccess({data: {...response.data, time: new Date().getTime()}}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchExportedOrgData = () => {
  return async (dispatch) => {

    dispatch(fetchStart());
    // console.log(id);
    try {
      const response = await axios.get(`/security/data`);
      // console.log(response);
      dispatch(fetchSuccess());
      dispatch(fetchExportDataSuccess({ data: { ...response.data, ttl: new Date().getTime() } }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchExportDataSuccess = ({ data }) => {
  return {
    type: FETCH_ORGANISATION_DATA_SUCCESS,
    data
  };
};
